<template>
  <div class="main" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="modal" @click="close"></div>
    <div class="modal-alert">
      <div class="title-close">
        <div class="title" style="margin-bottom: 0">任务转换</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>

      <div class="tips">
        1、转换的前提条件是新任务包的服务药企、总服务商、核算月、任务包、人名、手机号和原任务包的都一致；并且多个新任务包中的人员不可以重复；<br />
        2、原任务包和新任务包都未进行对账单流程才可进行转换；<br />
        3、转换时原和新任务包系统会自动锁包，防止中途修改任务包数据导致数据不一致的问题；<br />
        4、转换成功后，万一业务员需要调整任务，那么需将任务相关数据（如客户资料、产品资料）的指派人、指派核算单元等访问权限授予新的执行方。
      </div>

      <div class="sub-title">
        <el-button type="info" size="mini" @click="addTableData"
          >添加新接包方</el-button
        >
      </div>

      <div class="table-wrap">
        <el-table :data="tableData" :max-height="300" :span-method="spanMethod">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              <div v-if="!scope.row.errMsg">
                {{ getDisplayIndex(scope.$index) }}
              </div>

              <div v-else class="errMsg">
                {{ scope.row.errMsg }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="新接包公司" width="300">
            <template slot-scope="scope">
              <el-select
                class="select-wrap"
                v-model="scope.row.changeTenantGuid"
                placeholder="请选择新接包公司"
                filterable
                @change="(val) => onChangeTenant(val, scope)"
              >
                <el-option
                  v-for="item in tenantList"
                  :key="item.serviceTenantGuid"
                  :label="item.serviceTenantName"
                  :value="item.serviceTenantGuid"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="新任务包" width="300">
            <template slot-scope="scope">
              <el-select
                class="select-wrap"
                v-model="scope.row.changeTaskGuid"
                placeholder="请选择新任务包"
                filterable
                @change="(val) => onChangeTask(val, scope)"
              >
                <el-option
                  v-for="item in taskPackageMap[scope.row.changeTenantGuid]"
                  :key="item.guid"
                  :label="item.taskTitle"
                  :value="item.guid"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                class="fontC-red"
                type="text"
                @click="deleteTableData(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btns" @click="submit">确定</div>
      <div class="btns cancel" @click="close">取消</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      fullscreenLoading: false,
      tableData: [
        {
          changeTenantGuid: "",
          changeTaskGuid: "",
        },
      ],
      tenantList: [],
      taskPackageMap: {},
    };
  },
  created() {
    this.getTenantOperationRelList();
  },
  methods: {
    async onSubmit() {
      const changeTaskList = this.tableData.map((item) => {
        return {
          changeTenantGuid: item.changeTenantGuid,
          changeTaskGuid: item.changeTaskGuid,
        };
      });
      const params = {
        taskGuid: this.$route.query.guid,
        tenantGuid: this.detail.tenantGuid,
        isCancel: "N",
        changeTaskList: changeTaskList,
        submitTenantGuid: localStorage.guid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/task-change/data/add`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.close();
    },
    async checkList() {
      const changeTaskList = this.tableData.map((item) => {
        return {
          changeTenantGuid: item.changeTenantGuid,
          changeTaskGuid: item.changeTaskGuid,
        };
      });
      const params = {
        taskGuid: this.$route.query.guid,
        tenantGuid: this.detail.tenantGuid,
        isCancel: "N",
        changeTaskList: changeTaskList,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/task-change/data/check-list`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      const errMsg = data.data?.some((item) => {
        return item;
      });
      if (!errMsg) {
        return true;
      }
      // 插入错误信息
      this.tableData = this.tableData.flatMap((item, index) => {
        // 如果当前索引有对应的错误信息
        if (data.data[index]) {
          return [item, { errMsg: data.data[index] }];
        } else {
          // 没有对应的错误信息
          return [item];
        }
      });
      return false;
    },
    async checkData(guid, scope) {
      // inTaskGuid 用户选择的任务包 guid
      const params = {
        inTaskGuid: guid,
        outTaskGuid: this.$route.query.guid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.get(
        `/${serverConfig.msSalesPerformService}/task-change/data/check`,
        params
      );
      this.fullscreenLoading = false;
      // 先将错误删除
      if (
        this.tableData[scope.$index + 1] &&
        this.tableData[scope.$index + 1].errMsg
      ) {
        this.tableData.splice(scope.$index + 1, 1);
      }
      // 有最新的错误信息
      if (data.data) {
        // 需要在tableData 插入一项
        const insertIndex = scope.$index + 1;
        this.tableData.splice(insertIndex, 0, {
          errMsg: data.data,
        });
      }
      this.tableData = [...this.tableData];
    },
    // 新任务包
    async getList(val) {
      const params = {
        pageIndex: 1,
        pageSize: -1,
        lockStatus: 0, // 0 未锁定 1 已锁定
        isChangeService: "Y",
        approvalState: ["Y"],
        accountMonth: this.detail.accountMonth,
        serviceTenantGuid: val,
        isShowTest: true,
        isExcludeDataPermission: true,
        onlyMyData: false,
        state: ["已派发"],
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/task/data/get-list`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.taskPackageMap[val] = data.data.records;
      this.taskPackageMap = { ...this.taskPackageMap };
    },
    //新接包公司
    async getTenantOperationRelList() {
      const query = {
        isService: false,
        tenantGuid: this.detail.tenantGuid,
        // relType: 1,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.get(
        `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tenantList = data.data;
    },
    // 获取显示的序号（过滤掉错误行）
    getDisplayIndex(index) {
      let realIndex = 0;
      for (let i = 0; i <= index; i++) {
        if (!this.tableData[i].errMsg) {
          realIndex++;
        }
      }
      return realIndex;
    },

    spanMethod({ row, columnIndex }) {
      if (row.errMsg) {
        // 第一列合并为一整行
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 4, // 一共4列
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },

    deleteTableData(index) {
      const notDelContent = "请保留一条新接包记录";
      // 只有一行 不许删除
      if (this.tableData.length == 1) {
        this.$message.error(notDelContent);
        return;
      }
      // 两行的情况  其中一行是错误提示行, 不许删除
      if (this.tableData.length == 2 && this.tableData[1].errMsg) {
        this.$message.error(notDelContent);
        return;
      }
      // 删除当前行
      this.tableData.splice(index, 1);

      // 如果下一行是错误提示行，一并删除
      if (this.tableData[index] && this.tableData[index].errMsg) {
        this.tableData.splice(index, 1);
      }
    },
    /**检查错误信息 */
    checkError() {
      const errMsg = this.tableData.some((item) => {
        return item.errMsg;
      });
      if (errMsg) {
        this.$message.error("请检查错误信息");
        return false;
      }
      return true;
    },
    /**校验内容是否有值 && 无错误信息 */
    validateContent() {
      const isErrMsg = this.checkError();
      if (!isErrMsg) {
        return false;
      }
      const f = this.tableData.every((item) => {
        return item.changeTenantGuid && item.changeTaskGuid;
      });
      if (!f) {
        this.$message.error("请填写完整");
        return false;
      }
      return true;
    },
    addTableData() {
      const f = this.validateContent();
      if (!f) {
        return;
      }

      this.tableData.push({
        changeTenantGuid: "",
        changeTaskGuid: "",
      });
    },
    close() {
      this.$emit("close");
    },
    onChangeTenant(val, scope) {
      this.tableData[scope.$index].changeTenantGuid = val;
      this.tableData[scope.$index].changeTaskGuid = "";
      // 如果下一行是错误提示行，删除
      if (
        this.tableData[scope.$index + 1] &&
        this.tableData[scope.$index + 1].errMsg
      ) {
        this.tableData.splice(scope.$index + 1, 1);
      }
      this.tableData = [...this.tableData];
      this.getList(val);
    },
    async onChangeTask(val, scope) {
      this.tableData[scope.$index].changeTaskGuid = val;
      await this.checkData(val, scope);
      // 如果下一行是错误提示行，删除
      // if (
      //   this.tableData[scope.$index + 1] &&
      //   this.tableData[scope.$index + 1].errMsg
      // ) {
      //   this.tableData.splice(scope.$index + 1, 1);
      // }
      // this.tableData = [...this.tableData];
    },
    //提交
    async submit() {
      // 无数据 不许提交
      if (!this.tableData.length) {
        this.$message.error("请添加新接包方");
        return;
      }
      // 校验是否填写内容
      const validate = this.validateContent();
      if (!validate) {
        return;
      }
      const f = await this.checkList();
      if (!f) {
        return;
      }
      const res = await this.$confirm(
        "转包时，为防止数据不一致，系统会自动锁定任务包，确定转包吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      );
      if (!res) {
        return;
      }
      this.onSubmit();
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: 0.3;
}

.modal-alert {
  position: fixed;
  width: 800px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-bottom: 20px;
}

.title-close {
  height: 50px;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 18px;
  color: #212121;
}

.title-close div {
  height: 100%;
  line-height: 50px;
}

.modal-alert .btns {
  width: 60px;
  height: 28px;
  background: #4fa1a4;
  border-radius: 2px;
  color: #fff;
  margin-top: 15px;
  float: right;
  margin-right: 20px;
  line-height: 28px;
  cursor: pointer;
}

.modal-alert .close {
  cursor: pointer;
  color: #909399;
}

.modal-alert .close:hover {
  color: #409EFF;
}

.modal-alert .tips {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;
  color: red;
}

.modal-alert .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.modal-alert .sub-title span {
  background: #4fa1a4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/ .table_header {
  background-color: #f0f0f0 !important;
  padding: 10px 0;
  color: #323233;
  overflow-x: scroll;
}

/deep/ .el-table td {
  padding: 10px 0px;
}

/deep/.el-input-number__decrease {
  height: 33px;
  top: 3px;
}

/deep/ .el-input-number__increase {
  height: 33px;
  top: 3px;
}

.table-wrap {
  margin: 20px;
}

.btns.cancel {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color: #666;
}

.errMsg {
  color: #de4355;
  padding-left: 50px;
  line-height: 20px;
}
</style>
